<template>
  <div>
    <BaseTitle :title="$t('content.choose_child')" />
    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="white" />
    </div>
    <v-row v-else>
      <v-col v-for="item in items" :key="item.studentId" md="4">
        <div class="class-item">
          <img v-if="item.imageUrl" :src="item.imageUrl" class="user-photo mb-6" />
          <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo mb-6" />
          <strong class="class-item-textspan mb-4">{{ item.fullName }}</strong>
          <div class="mb-4">
            <svg-icon icon="bank" class="app-menu-icon mr-2" />
            <span class="class-item-title">{{ item.schoolName }} </span>
          </div>
          <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" :disabled="!item.classroomStudent" @click.prevent="setStudent(item)">
            {{ $t(item.classroomStudent ? 'content.see_activity' : 'content.no_data_class') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'ParentChild',
  props: {
    type: {
      type: String
    }
  },
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({
      items: 'ChildList/items',
      student: 'Auth/student'
    })
  },
  data: () => ({
    loading: true
  }),
  methods: {
    getData() {
      this.loading = true;
      return this.$store.dispatch('ChildList/fetchList').finally(() => (this.loading = false));
    },
    setStudent(item) {
      this.$store.commit('Auth/SET_STUDENT', item);
      this.$router.push({ name: 'ParentClassIndex' });
    }
  },
  created() {
    if (this.student) {
      this.$router.push({ name: 'ParentClassIndex' });
    } else {
      this.getData().then(student => {
        if (student.length == 1 && student.classroomStudent) {
          this.setStudent(student[0]);
        } else if (student.length == 0) {
          this.$router.push({ name: 'ParentClassIndex' });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  background: #fff;
  padding: 10px;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 240px;

  &-title {
    color: #00bf63;
    font-family: Montserrat;
    font-size: 12px;
    line-height: 14.63px;
    text-align: left;
  }

  &-textspan {
    color: #6d6d6d;
    font-family: Montserrat;
    font-size: 16px;
    line-height: 19px;
    text-align: left;
  }

  &:hover {
    background: #f8f8f8;
  }
}

.user {
  &-photo {
    width: 70px;
    height: 70px;
    overflow: hidden;
    border-radius: 100px;
    margin-right: 10px;
  }
}
.app-menu-icon {
  background: #fff;
  width: 25px;
  height: 15px;
}
</style>
